// Based on MaterialUI default breakpoints: https://mui.com/material-ui/customization/breakpoints/#default-breakpoints
export const BREAKPOINTS = {
  xs: "100%", // No max width
  sm: "600px",
  md: "900px",
  lg: "1200px",
  xl: "1536px",
};
